import { useContext } from 'react'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'

import {
  createPerson as apiCreatePerson,
  updatePerson as apiUpdatePerson
} from '../../../../../services/person'
import { pages } from '../../../../../config/pages'

import { PersonFormatted } from '../../../utils/formatPerson'
import { PersonFormContext } from '../context'

function isDate(value: any): value is Date {
  return value instanceof Date
}

export function usePerson() {
  const {
    person,
    responsible,
    partner,
    loading,
    setLoading,
    updatePersonState
  } = useContext(PersonFormContext)
  const navigate = useNavigate()

  function createPerson(data: Partial<PersonFormatted>) {
    Promise.resolve()
      .then(() => setLoading(true))
      .then(() => {
        const personData = {
          ...data,
          type: data.type || 'INDIVIDUAL',
          active: data.active !== undefined ? data.active : true,
          partnerId: data.partnerId || partner?.id
        }
        return apiCreatePerson(personData)
      })
      .then(data => updatePersonState(data))
      .then(() => {
        toast.info('Pessoa cadastrada com sucesso')
        navigate(pages.people.path)
      })
      .catch(err => {
        if (err.response?.status === 409) {
          toast.error('Este documento já está cadastrado.')
        } else {
          toast.error('Ocorreu um erro ao cadastrar a pessoa.')
        }
      })
      .finally(() => setLoading(false))
  }

  function updatePerson(data: Partial<PersonFormatted>) {
    if (!person?.id) {
      console.error('updatePerson called without person.id')
      return
    }

    Promise.resolve()
      .then(() => setLoading(true))
      .then(() => {
        const filteredData = Object.fromEntries(
          Object.entries(data).filter(
            ([, value]) => value !== undefined && value !== null
          )
        ) as Partial<PersonFormatted>

        // Handle birthDate conversion if it's a Date object
        if (filteredData.birthDate) {
          // Use the isDate type guard
          if (isDate(filteredData.birthDate)) {
            filteredData.birthDate = filteredData.birthDate.toISOString() as any
          }
          // If it's a string, it remains a string. No action needed.
        }
        return apiUpdatePerson(person.id, filteredData)
      })
      .then(data => updatePersonState(data))
      .then(() => {
        toast.info('O cadastro foi alterado')
        navigate(pages.people.path)
      })
      .catch(() => toast.error('Ocorreu um erro ao alterar o cadastro.'))
      .finally(() => setLoading(false))
  }

  return {
    person,
    responsible,
    partner,
    loading,
    setLoading,
    createPerson,
    updatePerson
  }
}
